import React from "react";
import PropTypes from "prop-types";

import {STATUS_COLORS} from "./colorConstants";
import ToolTip from "./ToolTip";

const AvailabilityStatusCIrcule = ({
  ifAvailable,
  tooltipMessage = "",
  color,
  onMouseEnter = () => {},
  onMouseLeave = () => {},
}) => {
  let statusColor = color ? color : STATUS_COLORS.RED;

  if (ifAvailable) {
    statusColor = STATUS_COLORS.GREEN;
  }

  return (
    <ToolTip title={tooltipMessage}>
      <div className="availability_circule_box" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className="outer_circle">
          <div className="inner_circle" style={{backgroundColor: statusColor}}></div>
        </div>
      </div>
    </ToolTip>
  );
};

AvailabilityStatusCIrcule.propTypes = {
  ifAvailable: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  color: PropTypes.oneOf([...Object.values(STATUS_COLORS), "done"]),
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
};

export default AvailabilityStatusCIrcule;
